/* esm.sh - micromark-extension-gfm-task-list-item@2.1.0 */
export * from "/*micromark-extension-gfm-task-list-item@2.1.0/esnext/micromark-extension-gfm-task-list-item.mjs";
